import { Injectable, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { TaasUserDetails, TaasJwtTokenDetails } from 'utimaco-common-ui-angular';

@Injectable({
  providedIn: 'root'
})
export class TaasUserService {

  private keycloak = inject(Keycloak);

  performLogout() {
    this.keycloak?.logout();
  }

  async getCurrentUserDetails(): Promise<TaasUserDetails> {
    await this.keycloak.updateToken(5);
    const tokenString = this.keycloak.token!;
    const tokenObject: TaasJwtTokenDetails = JSON.parse(atob(tokenString.split('.')[1]));

    const realmRoles = tokenObject.realm_access?.roles || [];
    const resourceRoles = Object.entries(tokenObject.resource_access || {})
      .flatMap(([resourceName, resource]: [string, { roles: string[] }]) =>
        (resource.roles || []).map((role: string) => `${resourceName}:${role}`)
      );
    const userDetails: TaasUserDetails = {
      givenName: tokenObject.given_name,
      familyName: tokenObject.family_name,
      email: tokenObject.email,
      initials: tokenObject.given_name.trim().substring(0, 1) + tokenObject.family_name.trim().substring(0, 1),
      roles: [...new Set([...realmRoles, ...resourceRoles])]
    }
    return userDetails;
  }
}
